
import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
  TableRow, Table,
  TableHead,
  TableBody,
  TableCell,
   TableContainer,
                Paper,
  Checkbox, FormControlLabel, FormHelperText, Divider,
  CircularProgress,
} from "@material-ui/core";

import { Card, Box, Typography, Avatar, Chip, Collapse, InputAdornment, IconButton, Tooltip, Menu } from "@material-ui/core";
import CalenderAssignmentService from "./Locality/Service/calenderAssignmentService";
import AddClassService from "./Locality/Service/addClassService";
import StudentService from "./Locality/Service/studentService";
import SectionService from "./Locality/Service/sectionService";
import IconMasterService from "./Locality/Service/iconMasterService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import FilterListIcon from '@material-ui/icons/FilterList';
import CloseIcon from '@material-ui/icons/Close';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SchoolIcon from '@material-ui/icons/School';
import PersonIcon from '@material-ui/icons/Person';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import EventIcon from '@material-ui/icons/Event';
import ImageIcon from '@material-ui/icons/Image';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DescriptionIcon from '@material-ui/icons/Description';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { makeStyles } from '@material-ui/core/styles';

const getDocumentFileName = (url) => {
  try {
    const path = (url || '').split('/').pop() || url;
    return (path || '').split('?')[0] || 'school-calendar.docx';
  } catch {
    return 'school-calendar.docx';
  }
};

const fileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

const mergeSelectedFiles = (existing, incoming) => {
  const keys = new Set(existing.map(fileKey));
  return [...existing, ...incoming.filter((f) => !keys.has(fileKey(f)))];
};

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '1.9rem',
    color: '#0f2d4d',
    lineHeight: 1.2,
  },
  pageSubtitle: {
    color: '#6b7280',
    fontSize: '0.9rem',
    marginTop: 2,
  },
  primaryBtn: {
    backgroundColor: '#1769d6',
    color: '#fff',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    padding: '8px 18px',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  noteBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#eef4ff',
    border: '1px solid #d6e4ff',
    marginBottom: theme.spacing(2),
  },
  noteIconWrap: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: '#1769d6',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  filtersCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  filtersTopRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  filtersChip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    padding: '6px 14px',
    borderRadius: 8,
    backgroundColor: '#f4f6fa',
    border: '1px solid #e6eaf0',
    cursor: 'pointer',
    fontWeight: 600,
    color: '#0f2d4d',
    fontSize: '0.9rem',
  },
  countBadge: {
    backgroundColor: '#1769d6',
    color: '#fff',
    borderRadius: 10,
    fontSize: '0.72rem',
    fontWeight: 700,
    minWidth: 18,
    height: 18,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 5px',
  },
  fieldLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: '0.78rem',
    fontWeight: 600,
    color: '#46566b',
    marginBottom: 6,
  },
  resetBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
    border: '1px solid #e6eaf0',
  },
  tableCard: {
    borderRadius: 14,
    border: '1px solid #e6eaf0',
    boxShadow: '0 2px 10px rgba(16,42,67,0.06)',
    overflow: 'hidden',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    borderBottom: '1px solid #eef1f5',
  },
  iconBtnOutlined: {
    border: '1px solid #e6eaf0',
    borderRadius: 8,
    padding: 7,
  },
  headCell: {
    backgroundColor: '#f4f6fa',
    color: '#46566b',
    fontWeight: 700,
    fontSize: '0.8rem',
    borderBottom: '1px solid #e6eaf0',
    whiteSpace: 'nowrap',
  },
  classChip: {
    backgroundColor: '#eef4ff',
    color: '#1769d6',
    fontWeight: 600,
    height: 24,
  },
  sectionChip: {
    backgroundColor: '#f3efff',
    color: '#7c4dff',
    fontWeight: 600,
    height: 24,
  },
  studentAvatar: {
    width: 30,
    height: 30,
    fontSize: '0.8rem',
    backgroundColor: '#1769d6',
  },
  imagesBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    fontSize: '0.78rem',
  },
  dialogPaper: {
    borderRadius: 14,
    width: 520,
    maxWidth: '95vw',
  },
  dialogTitleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2.5),
    borderBottom: '1px solid #eef1f5',
  },
  dialogTitleText: {
    fontWeight: 700,
    fontSize: '1.15rem',
    color: '#0f2d4d',
  },
  dialogBody: {
    padding: theme.spacing(2.5),
  },
  sectionLabel: {
    fontWeight: 700,
    color: '#46566b',
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: theme.spacing(1.25),
  },
  formSection: {
    marginBottom: theme.spacing(2.5),
  },
  uploadBox: {
    border: '1px dashed #c5d3e6',
    borderRadius: 10,
    backgroundColor: '#f8fafc',
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  uploadBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: '#1769d6',
    color: '#fff',
    '&:hover': { backgroundColor: '#125bbd' },
  },
  previewThumb: {
    width: 84,
    height: 84,
    objectFit: 'cover',
    borderRadius: 8,
    border: '1px solid #e6eaf0',
  },
  removeThumbBtn: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    padding: 2,
    minWidth: 'auto',
  },
  pendingPanel: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderRadius: 10,
    border: '1px solid #e6eaf0',
    backgroundColor: '#fff',
  },
  pendingFileName: {
    fontSize: '0.72rem',
    color: '#6b7280',
    marginTop: 4,
    maxWidth: 84,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  dialogFooter: {
    padding: theme.spacing(1.5, 2.5),
    borderTop: '1px solid #eef1f5',
  },
  cancelBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    color: '#46566b',
  },
  addBtn: {
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: 8,
    backgroundColor: '#1769d6',
    color: '#fff',
    boxShadow: '0 4px 10px rgba(23,105,214,0.25)',
    '&:hover': { backgroundColor: '#125bbd' },
    '&.Mui-disabled': { backgroundColor: '#cbd5e1', color: '#fff' },
  },
}));
export default function CalenderAssignment() {
  const history = useHistory();

  const columnConfig = [
    { id: 'student', label: 'Student' },
    { id: 'eventName', label: 'Event Name' },
    { id: 'class', label: 'Class' },
    { id: 'section', label: 'Section' },
    { id: 'observation', label: 'Special notes' },
    { id: 'date', label: 'Date' },
    { id: 'images', label: 'Images' },
  ];
  const [noteOpen, setNoteOpen] = useState(true);
  const [filtersOpen, setFiltersOpen] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [columnMenuAnchor, setColumnMenuAnchor] = useState(null);
  const [actionMenu, setActionMenu] = useState({ anchor: null, row: null });
  const [visibleCols, setVisibleCols] = useState({
    student: true,
    eventName: true,
    class: true,
    section: true,
    observation: true,
    date: true,
    images: true,
  });

  const openActionMenu = (e, row) => setActionMenu({ anchor: e.currentTarget, row });
  const closeActionMenu = () => setActionMenu({ anchor: null, row: null });

  const eventHasImages = (row) =>
    Array.isArray(row?.imageURL) && row.imageURL.filter(Boolean).length > 0;
  const [images, setImages] = useState([]);
  const [imageslist, setImagesList] = useState([]);
  const fileInputRef = useRef(null);
  const [message, setMessage] = useState("");
  const classes = useStyles();
  const [studentList, setStudentList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [listClassId, setListClassId] = useState("");
  const [listSectionId, setListSectionId] = useState("");
  const [listSectionList, setListSectionList] = useState([]);
  const [calenderAssignmentList, setCalenderAssignmentList] = useState([]);
  const [activeIcons, setActiveIcons] = useState([]);
  const [dueDate, setFormDueDate] = useState("");
  const [age, setAge] = React.useState('');
  var [error, setError] = useState(null);
  var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [addEventLoading, setAddEventLoading] = useState(false);
  const [schoolCalenderDocs, setSchoolCalenderDocs] = useState([]);
  const [schoolCalenderClassId, setSchoolCalenderClassId] = useState('');
  const [schoolCalenderUploading, setSchoolCalenderUploading] = useState(false);
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(100);
  const current = new Date();
  var [classId, setClassId] = useState("");
  const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
  var [dateValue, setDateValue] = useState(date);
  const [eventId, setEventId] = useState('');
  const [year, month, day] = date.split("-");
  const [calenderAssignment, setCalenderAssignment] = useState({
    eventName: '',
    imageURL: [],
    observation: '',
    video: '',
    studentId: [],
    date: '',
    isEventForAllStudent: false,
    iconId: '',
    sectionId: '',
  });

 
  const validationSchema = Yup.object().shape({
    eventName: Yup.string().required('event Name is required'),
    studentId: Yup.array(),
    video: Yup.string(),
    date: Yup.string().required('Event Date is required'),
    observation: Yup.string(),
    classId: Yup.string(),
    sectionId: Yup.string(),
    imageURL: Yup.array(),
    isEventForAllStudent: Yup.boolean(),
    iconId: Yup.string(),
  });
 
  const verifyeetnt = () => {
    console.log(formik)
  }
  const handleOpen = (status) => {
    if (status) {
      const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
      const initial = {
        eventName: '',
        imageURL: [],
        observation: '',
        video: '',
        studentId: [],
        date: '',
        isEventForAllStudent: false,
        iconId: '',
        sectionId: '',
        classId: userDetails.role === "TEACHER" ? (userDetails.classId || '') : '',
      };
      if (userDetails.role === "TEACHER" && userDetails.classId) {
        getSectionListByClass(userDetails.classId);
        getStudentList(userDetails.classId, userDetails.sectionId || undefined);
        initial.sectionId = userDetails.sectionId || '';
      }
      setCalenderAssignment(initial);
    }
    setAddEventLoading(false);
    setOpen(true);
  };
  const handleChangePage = (event, newpage) => {
    setpg(newpage);
  }
  const handleChangeRowsPerPage = (event) => {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }
  useEffect(() => {
    getAddClassList();
    getActiveIcons();
    fetchSchoolCalender();
    return () => {
      setCalenderAssignmentList([]);
      setStudentList([]);
    }
  }, []);

  useEffect(() => {
    getCalenderAssignmentList();
  }, [listClassId, listSectionId]);

  useEffect(() => {
    const refreshList = () => getCalenderAssignmentList();
    window.addEventListener("calendarEventUpdated", refreshList);
    return () => window.removeEventListener("calendarEventUpdated", refreshList);
  }, [listClassId, listSectionId]);

  const getActiveIcons = () => {
    const body = { status: 'active' };
    IconMasterService.findIconMasterList(body)
      .then((res) => {
        const list = Array.isArray(res) ? res : [];
        setActiveIcons(list.filter((icon) => icon.imageUrl));
      })
      .catch((err) => {
        console.error("Error fetching active icons:", err);
      });
  };
  const dateAndTime = (date) => {

    const systemDate = new Date(date);
    const formattedDateTime = systemDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true,

    });
    return formattedDateTime;
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormDueDate(value);
  };

  const pendingPreviews = useMemo(
    () =>
      images.map((file) => ({
        file,
        key: fileKey(file),
        url: URL.createObjectURL(file),
      })),
    [images],
  );

  useEffect(() => {
    return () => {
      pendingPreviews.forEach((preview) => URL.revokeObjectURL(preview.url));
    };
  }, [pendingPreviews]);

  const handleFileChange = (e) => {
    const picked = Array.from(e.target.files || []);
    if (!picked.length) return;
    setImages((prev) => mergeSelectedFiles(prev, picked));
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const removePendingImageAt = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };
  const handleUpload = async (e) => {
    e.preventDefault();

    if (!images || images.length === 0) {
      setMessage("Please select images first.");
      return;
    }

    try {
      for (const image of images) {
        const formData = new FormData();
        formData.append("image", image);
        formData.append("imageName", image.name);
        // eslint-disable-next-line no-await-in-loop
        const res = await CalenderAssignmentService.uploadImage(formData);
        const url = res?.url || res?.data?.url;
        if (!url) throw new Error("Upload succeeded but no image URL returned.");
        setImagesList((prev) => [...(Array.isArray(prev) ? prev : []), url]);
      }
      alert("Images uploaded successfully");
      setImages([]);
      if (fileInputRef.current) fileInputRef.current.value = '';
    } catch (error) {
      console.error("Error uploading images:", error);
      alert(error?.message || "An error occurred while uploading the images.");
    }

  };

  // Function to format date to D/M/Y format
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        // If dateString is already in YYYY-MM-DD format, parse it manually
        const parts = dateString.split("-");
        if (parts.length === 3) {
          const day = parts[2];
          const month = parts[1];
          const year = parts[0];
          return `${day}/${month}/${year}`;
        }
        return dateString;
      }
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const fetchSchoolCalender = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!userDetails.schooleId) return;

    CalenderAssignmentService.getCalenderDocument({ schooleId: userDetails.schooleId })
      .then((res) => {
        const list = Array.isArray(res) ? res.filter((row) => row.schoolCalenderDocument) : [];
        setSchoolCalenderDocs(list);
      })
      .catch(() => {
        setSchoolCalenderDocs([]);
      });
  };

  const getCalenderAssignmentList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    const params = {};
    if (userDetails.schooleId) params.schooleId = userDetails.schooleId;
    if (listClassId) params.classId = listClassId;
    if (listSectionId) params.sectionId = listSectionId;
    CalenderAssignmentService.getAllCalenderAssignment(params)
      .then((res) => {
        setCalenderAssignmentList(res);
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  const saveSchoolCalenderDocument = async (documentUrl) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};

    const payload = {
      schoolCalenderDocument: documentUrl,
      schooleId: userDetails.schooleId,
      status: true,
    };
    if (schoolCalenderClassId) {
      payload.classId = schoolCalenderClassId;
    }

    await CalenderAssignmentService.addCalenderDocument(payload);

    fetchSchoolCalender();
    return true;
  };

  const handleSchoolCalenderUpload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const isValidWord =
      /\.(docx?|DOCX?)$/.test(file.name) ||
      file.type === 'application/msword' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    if (!isValidWord) {
      alert('Please upload a Word document (.doc or .docx).');
      if (e.target) e.target.value = '';
      return;
    }

    setSchoolCalenderUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('imageName', file.name);
      const res = await CalenderAssignmentService.uploadImage(formData);
      const url = res?.url || res?.data?.url;
      if (!url) throw new Error('Upload succeeded but no document URL returned.');

      const saved = await saveSchoolCalenderDocument(url);
      if (saved) {
        alert('School calendar uploaded successfully.');
      }
    } catch (error) {
      console.error('School calendar upload failed:', error);
      alert(error?.message || 'Failed to upload school calendar.');
    } finally {
      setSchoolCalenderUploading(false);
      if (e.target) e.target.value = '';
    }
  };

  const handleSchoolCalenderRemove = async (doc) => {
    if (!doc?._id) return;
    const confirmDelete = window.confirm('Remove this school calendar document?');
    if (!confirmDelete) return;

    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    try {
      await CalenderAssignmentService.deleteCalenderDocument(doc._id, { schooleId: userDetails.schooleId });
      fetchSchoolCalender();
      alert('School calendar document removed.');
    } catch (error) {
      alert(error?.response?.data?.message || 'Failed to remove school calendar document.');
    }
  };

  const handleOpen1 = () => {
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen(false);
    setImages([]);
    setImagesList([]);
    if (fileInputRef.current) fileInputRef.current.value = '';
    // Reset form when closing
    const resetData = {
      eventName: '',
      imageURL: [],
      observation: '',
      video: '',
      studentId: [],
      date: '',
      isEventForAllStudent: false,
      iconId: '',
      sectionId: '',
    };
    setCalenderAssignment(resetData);
  };

  const handleClose1 = () => {
    setOpen1(false);
  };
  const getSectionListByClass = (classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!classId) {
      setSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    }).then((res) => {
      let list = Array.isArray(res) ? res : [];
      setSectionList(list);
    }).catch(() => setSectionList([]));
  };

  const getListSectionListByClass = (classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
    if (!classId) {
      setListSectionList([]);
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId,
    }).then((res) => {
      setListSectionList(Array.isArray(res) ? res : []);
    }).catch(() => setListSectionList([]));
  };

  const onListClassChange = (e) => {
    const id = e.target.value;
    setListClassId(id);
    setListSectionId("");
    setpg(0);
    getListSectionListByClass(id);
  };

  const onListSectionChange = (e) => {
    setListSectionId(e.target.value);
    setpg(0);
  };

  const getAddClassList = (event) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
      // if (userDetails.role === "TEACHER") {
      //   res = res.filter(res => res._id === userDetails.classId);
      // }
      setAddClassList(res);
      if (userDetails.classId) {
        setClassId(userDetails.classId);
        setCalenderAssignment((prev) => ({ ...prev, classId: userDetails.classId, sectionId: userDetails.sectionId || '' }));
        getSectionListByClass(userDetails.classId);
        getStudentList(userDetails.classId, userDetails.sectionId || undefined);
      } else {
        setClassId("");
      }
    }).catch((err) => {
      // setError(err.message);
    });
  }
 
  const editCalenderAssignment = (calenderassignment, status) => {
    const obj = JSON.parse(JSON.stringify(calenderassignment, status));
    obj.classId = calenderassignment.classId ? calenderassignment.classId._id : '';
    obj.sectionId = calenderassignment.sectionId ? (calenderassignment.sectionId._id || calenderassignment.sectionId) : '';
    obj.studentId = Array.isArray(calenderassignment.studentId)
    ? calenderassignment.studentId.map(student => student._id)
    : calenderassignment.studentId
    
    // Handle iconId - it can be an object (populated) or a string ID
    if (calenderassignment.iconId) {
      if (typeof calenderassignment.iconId === 'object' && calenderassignment.iconId._id) {
        obj.iconId = calenderassignment.iconId._id;
      } else if (typeof calenderassignment.iconId === 'string') {
        obj.iconId = calenderassignment.iconId;
      } else {
        obj.iconId = '';
      }
    } else {
      obj.iconId = '';
    }

    // Set existing images if any
    if (calenderassignment.imageURL && Array.isArray(calenderassignment.imageURL) && calenderassignment.imageURL.length > 0) {
      setImagesList(calenderassignment.imageURL);
    } else {
      setImagesList([]);
    }

    getSectionListByClass(obj.classId);
    getStudentList(obj.classId, obj.sectionId || undefined);
    getAddClassList({ target: { value: obj.superActivityId } }, obj);

    if (status) {
      delete obj._id;
    }
    setCalenderAssignment(obj);
    handleOpen()
  }
  const removeImage = (index, imageURL) => {
    const urlToRemove = imageURL || (Array.isArray(imageslist) ? imageslist[index] : undefined);
    const updatedList = (Array.isArray(imageslist) ? imageslist : []).filter((_, i) => i !== index);
    setImagesList(updatedList);
    formik.setFieldValue("imageURL", updatedList);
    setCalenderAssignment((prev) => ({ ...prev, imageURL: updatedList }));

    if (!urlToRemove) return;
    CalenderAssignmentService.deleteAzureImage({ imageURL: urlToRemove }).catch(() => {
      // ignore delete failures; UI stays responsive
    });
  };
  const deleteCalenderAssignment = (calenderassignment) => {
    if (calenderassignment) {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this Event?"
      );
      
      if (!confirmDelete) {
        return;
      }

      CalenderAssignmentService.deleteCalenderAssignment(calenderassignment).then((res) => {
        getCalenderAssignmentList();
        // Dispatch custom event to notify Calendar.js to refresh
        window.dispatchEvent(new CustomEvent('calendarEventDeleted', { 
          detail: { eventId: calenderassignment._id } 
        }));
        alert("Event deleted successfully!");
      }).catch((err) => {
        alert(err.response?.data?.message || "Error deleting event");
      });
    }
  }


  const getStudentList = (classIdValue, sectionIdValue) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    if (!classIdValue) {
      setStudentList([]);
      return;
    }
    const getSpeList = { classId: classIdValue };
    if (sectionIdValue) getSpeList.sectionId = sectionIdValue;
    StudentService.getAllStudentById(userDetails.schooleId, getSpeList).then((res) => {
      const studentDetails = (res || []).map((r) => ({
        _id: r._id,
        studentName: `${r.firstName || ''} ${r.lastName || ''}`.trim(),
        status: true,
      }));
      setStudentList(studentDetails);
    }).catch(() => setStudentList([]));
  }

  const formik = useFormik({
    initialValues: calenderAssignment,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      if (!values.isEventForAllStudent && (!values.studentId || values.studentId.length === 0)) {
        alert('Please select at least one student.');
        return;
      }

      if (values.isEventForAllStudent) {
        if (!values.classId) {
          alert('Please select a class first.');
          return;
        }
        const effectiveSectionId = values.sectionId || null;
        if (studentList.length === 0) {
          alert(
            effectiveSectionId
              ? 'No students found in the selected section. Please add students to this section or choose a different section.'
              : 'No students found in the selected class. Please add students to this class or choose a different class.'
          );
          return;
        }
      }

      setAddEventLoading(true);
      const userDetails = JSON.parse(localStorage.getItem("userDetail"));
      values.schooleId = userDetails.schooleId;
      values.studentId = values.studentId ? values.studentId : null;
      values.iconId = values.iconId || null;
      values.sectionId = values.sectionId || null;
      values.imageURL = imageslist;
      if (calenderAssignment._id) {

        CalenderAssignmentService.upadeCalenderAssignment(values).then((res) => {

          handleClose();
          getCalenderAssignmentList();
          resetForm()
          setImagesList([])
          // Dispatch custom event to notify Calendar.js to refresh
          window.dispatchEvent(new CustomEvent('calendarEventUpdated', { 
            detail: { eventId: calenderAssignment._id } 
          }));
          alert(" Event Updated Successfully.");
        }).catch((err) => {
          alert(err.response?.data?.message || "Error updating event");
        }).finally(() => setAddEventLoading(false));
      }
      else {
        CalenderAssignmentService.creteCalenderAssignment(values).then((res) => {
          getCalenderAssignmentList();
          resetForm();
          handleClose();
          // Dispatch custom event to notify Calendar.js to refresh
          window.dispatchEvent(new CustomEvent('calendarEventAdded', { 
            detail: { event: res } 
          }));
          alert(" Event Added Successfully.");
          setImagesList([])
        })
          .catch((err) => {
            alert(err.response?.data?.message || "Error adding event");
          })
          .finally(() => setAddEventLoading(false));
      }

    },
  });

  const test = () => {
    console.log(formik)
  };
  const handleCheck = (event, item) => {
    // event.sounds.SPL
    event.sounds[item] = !event.sounds[item];
    // obj['a'] = true;

    StudentService.upadeStudent(event).then((res) => {
      getStudentList();

    })
      .catch((err) => {
        alert(err.response.data.message)
      })

  };
  // const imageArtist = (eventdetails) => {
  //   getEventImageList(eventdetails.id);
  //   setEventId(eventdetails.id)

  // }
  const getCalenderAssignmentImageList = (eventId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    // CommonService.postRequest(IMAGES.GET+"/getlist", {artiesId:eventId}).then((res) => {
    //     setEventImageList(res);
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue, "eventId": userDetails.calenderAssignmentId
    }
    CalenderAssignmentService.creteImages(keys).then((res) => {
      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

    });
  }
  const onSubmit = data => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    const keys = {
      "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
      "date": dateValue
    }
    CalenderAssignmentService.creteCalenderAssignment(keys).then((res) => {

      setDateValue("");
      setStudentList([]);
      alert(" Event Successfully.");
    }).catch((err) => {

      alert(err.response.data.message);
    });
  };
  const activeFilterCount = (listClassId ? 1 : 0) + (listSectionId ? 1 : 0);

  const handleResetFilters = () => {
    setListClassId("");
    setListSectionId("");
    setListSectionList([]);
    setpg(0);
  };

  const studentNamesText = (row) => {
    if (row.isEventForAllStudent) return "All Students";
    return (Array.isArray(row.studentId) ? row.studentId : [])
      .map((s) => `${s.firstName || ''} ${s.lastName || ''}`.trim())
      .join(", ");
  };

  const filteredList = calenderAssignmentList.filter((row) => {
    if (row.isSchoolCalender) return false;
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;
    return (
      (row.eventName || '').toLowerCase().includes(term) ||
      studentNamesText(row).toLowerCase().includes(term) ||
      (row.classId?.className || '').toLowerCase().includes(term)
    );
  });

  const visibleColCount = Object.values(visibleCols).filter(Boolean).length + 1;

  return (
    <Box p={{ xs: 1, sm: 2 }}>
      <Box className={classes.pageHeader}>
        <Box>
          <Typography className={classes.pageTitle}>Calendar Of Events</Typography>
          <Typography className={classes.pageSubtitle}>
            Create and manage class events, attach images, and track them by class and section.
          </Typography>
        </Box>
        <Button
          className={classes.primaryBtn}
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => handleOpen(true)}
        >
          Add Event
        </Button>
      </Box>

      <Card elevation={0} className={classes.filtersCard} style={{ marginBottom: 16 }}>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gridGap={16}>
          <Box flex={1} minWidth={240}>
            <Typography style={{ fontWeight: 700, color: '#0f2d4d', fontSize: '1.05rem' }}>
              School Calendar Document
            </Typography>
            <Typography style={{ color: '#6b7280', fontSize: '0.85rem', marginTop: 4 }}>
              Upload school calendars as Word documents (.doc or .docx). You can add multiple files. Parents can download them from their calendar page.
            </Typography>
            {schoolCalenderDocs.length > 0 && (
              <Box mt={1.5} display="flex" flexDirection="column" gridGap={8}>
                {schoolCalenderDocs.map((doc) => (
                  <Box
                    key={doc._id}
                    display="flex"
                    alignItems="center"
                    gridGap={8}
                    p={1.5}
                    style={{
                      borderRadius: 10,
                      backgroundColor: '#eef4ff',
                      border: '1px solid #d6e4ff',
                    }}
                  >
                    <DescriptionIcon style={{ color: '#1769d6' }} />
                    <Box flex={1} minWidth={0}>
                      <Typography style={{ fontWeight: 600, color: '#0f2d4d', fontSize: '0.9rem' }}>
                        {getDocumentFileName(doc.schoolCalenderDocument)}
                      </Typography>
                      <Typography style={{ fontSize: '0.78rem', color: '#6b7280', marginTop: 2 }}>
                        {doc.classId?.className ? `Class: ${doc.classId.className}` : 'All classes'}
                      </Typography>
                    </Box>
                    <Button
                      size="small"
                      startIcon={<GetAppIcon style={{ fontSize: 18 }} />}
                      onClick={() => window.open(doc.schoolCalenderDocument, '_blank', 'noopener,noreferrer')}
                      style={{ textTransform: 'none', color: '#1769d6' }}
                    >
                      Open
                    </Button>
                    <IconButton
                      size="small"
                      onClick={() => handleSchoolCalenderRemove(doc)}
                      disabled={schoolCalenderUploading}
                    >
                      <DeleteIcon style={{ fontSize: 18, color: '#e53935' }} />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
          <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={10}>
            <Box>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Class (optional)
              </Typography>
              <FormControl variant="outlined" size="small" style={{ minWidth: 180 }}>
                <Select
                  value={schoolCalenderClassId}
                  displayEmpty
                  onChange={(e) => setSchoolCalenderClassId(e.target.value)}
                  disabled={schoolCalenderUploading}
                >
                  <MenuItem value=""><em>All Classes</em></MenuItem>
                  {addClassList.map(({ _id, className }) => (
                    <MenuItem key={_id} value={_id}>{className}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <input
              id="school-calender-upload"
              type="file"
              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              style={{ display: 'none' }}
              disabled={schoolCalenderUploading}
              onChange={handleSchoolCalenderUpload}
            />
            <label htmlFor="school-calender-upload">
              <Button
                component="span"
                variant="contained"
                className={classes.primaryBtn}
                startIcon={
                  schoolCalenderUploading ? (
                    <CircularProgress size={18} style={{ color: '#fff' }} />
                  ) : (
                    <CloudUploadIcon />
                  )
                }
                disabled={schoolCalenderUploading}
              >
                Add Word Document
              </Button>
            </label>
          </Box>
        </Box>
      </Card>

      {noteOpen && (
        <Box className={classes.noteBanner}>
          <Box className={classes.noteIconWrap}>
            <InfoOutlinedIcon style={{ fontSize: 18 }} />
          </Box>
          <Box flex={1}>
            <Typography style={{ fontWeight: 600, color: '#1f3a5f', fontSize: '0.9rem' }}>
              Manage your events
            </Typography>
            <Typography style={{ color: '#46566b', fontSize: '0.85rem', marginTop: 2 }}>
              Use the actions menu on each row to edit or delete an event. Add or update photos with the "Images" button.
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setNoteOpen(false)}>
            <CloseIcon style={{ fontSize: 18, color: '#7a8aa0' }} />
          </IconButton>
        </Box>
      )}

      <Card elevation={0} className={classes.filtersCard}>
        <Box className={classes.filtersTopRow}>
          <span className={classes.filtersChip} onClick={() => setFiltersOpen((v) => !v)}>
            <FilterListIcon style={{ fontSize: 18 }} />
            Filters
            {activeFilterCount > 0 && <span className={classes.countBadge}>{activeFilterCount}</span>}
            {filtersOpen ? <ExpandMoreIcon style={{ fontSize: 18 }} /> : <ChevronRightIcon style={{ fontSize: 18 }} />}
          </span>
        </Box>

        <Collapse in={filtersOpen}>
          <Grid container spacing={2} style={{ marginTop: 8 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Class
              </Typography>
              <FormControl variant="outlined" size="small" fullWidth>
                <Select value={listClassId} displayEmpty onChange={onListClassChange}>
                  <MenuItem value=""><em>All Classes</em></MenuItem>
                  {addClassList.map(({ _id, className }) => (
                    <MenuItem key={_id} value={_id}>{className}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography className={classes.fieldLabel}>
                <SchoolIcon style={{ fontSize: 16 }} /> Section
              </Typography>
              <FormControl variant="outlined" size="small" fullWidth disabled={!listClassId}>
                <Select value={listSectionId} displayEmpty onChange={onListSectionChange}>
                  <MenuItem value=""><em>All Sections</em></MenuItem>
                  {listSectionList.map(({ _id, sectionName }) => (
                    <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
              <Button className={classes.resetBtn} variant="outlined" onClick={handleResetFilters}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </Collapse>
      </Card>

      <Card elevation={0} className={classes.tableCard}>
        <Box className={classes.toolbar}>
          <Box display="flex" alignItems="center" gridGap={10}>
            <Typography style={{ fontWeight: 700, color: '#0f2d4d' }}>
              {filteredList.length} Event{filteredList.length !== 1 ? 's' : ''}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gridGap={10}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search events..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ fontSize: 18, color: '#9aa6b6' }} />
                  </InputAdornment>
                ),
              }}
            />
            <Tooltip title="Columns">
              <IconButton className={classes.iconBtnOutlined} size="small" onClick={(e) => setColumnMenuAnchor(e.currentTarget)}>
                <ViewColumnIcon style={{ fontSize: 20, color: '#46566b' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Refresh">
              <IconButton className={classes.iconBtnOutlined} size="small" onClick={getCalenderAssignmentList}>
                <RefreshIcon style={{ fontSize: 20, color: '#46566b' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <TableContainer component={Paper} elevation={0} style={{ maxHeight: 520 }}>
          <Table stickyHeader className="mb-0 dashboard-table-row-hover" size="small">
            <TableHead>
              <TableRow>
                {columnConfig.filter((c) => visibleCols[c.id]).map((c) => (
                  <TableCell key={c.id} className={classes.headCell}>{c.label}</TableCell>
                ))}
                <TableCell className={classes.headCell} align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={visibleColCount} align="center" style={{ padding: 32, color: '#7a8aa0' }}>
                    No events found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredList.slice(pg * rpg, pg * rpg + rpg).map((calenderassignment) => (
                  <TableRow key={calenderassignment._id} hover>
                    {visibleCols.student && (
                      <TableCell>
                        {calenderassignment.isEventForAllStudent ? (
                          <Chip size="small" label="All Students" className={classes.classChip} />
                        ) : (
                          <Box display="flex" alignItems="center" gridGap={8}>
                            <Avatar className={classes.studentAvatar}>
                              {(calenderassignment.studentId?.[0]?.firstName || '?').charAt(0).toUpperCase()}
                            </Avatar>
                            <span style={{ fontSize: '0.85rem' }}>{studentNamesText(calenderassignment) || '-'}</span>
                          </Box>
                        )}
                      </TableCell>
                    )}
                    {visibleCols.eventName && (
                      <TableCell style={{ fontWeight: 600, color: '#0f2d4d' }}>{calenderassignment.eventName}</TableCell>
                    )}
                    {visibleCols.class && (
                      <TableCell>
                        {calenderassignment.classId ? (
                          <Chip size="small" label={calenderassignment.classId.className} className={classes.classChip} />
                        ) : '-'}
                      </TableCell>
                    )}
                    {visibleCols.section && (
                      <TableCell>
                        {calenderassignment.sectionId ? (
                          <Chip size="small" label={calenderassignment.sectionId.sectionName || calenderassignment.sectionId} className={classes.sectionChip} />
                        ) : '-'}
                      </TableCell>
                    )}
                    {visibleCols.observation && (
                      <TableCell style={{ color: '#46566b' }}>{calenderassignment.observation || '-'}</TableCell>
                    )}
                    {visibleCols.date && (
                      <TableCell>
                        <Box display="flex" alignItems="center" gridGap={6} style={{ color: '#46566b' }}>
                          <EventIcon style={{ fontSize: 16, color: '#9aa6b6' }} />
                          {formatDate(calenderassignment.date)}
                        </Box>
                      </TableCell>
                    )}
                    {visibleCols.images && (
                      <TableCell>
                        <Button
                          size="small"
                          variant="contained"
                          className={classes.imagesBtn}
                          startIcon={<ImageIcon style={{ fontSize: 16 }} />}
                          style={{
                            backgroundColor: eventHasImages(calenderassignment) ? '#0d9488' : '#1769d6',
                            color: '#fff',
                          }}
                          onClick={() =>
                            history.push(`/app/calenderassignment/${calenderassignment._id}/add-images`)
                          }
                        >
                          {eventHasImages(calenderassignment) ? 'Edit Images' : 'Add Images'}
                        </Button>
                      </TableCell>
                    )}
                    <TableCell align="right">
                      <IconButton size="small" onClick={(e) => openActionMenu(e, calenderassignment)}>
                        <MoreVertIcon style={{ fontSize: 20, color: '#46566b' }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[1000, 10000, 1000000]}
          count={filteredList.length}
          page={pg}
          onPageChange={handleChangePage}
          rowsPerPage={rpg}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Menu
        anchorEl={columnMenuAnchor}
        open={Boolean(columnMenuAnchor)}
        onClose={() => setColumnMenuAnchor(null)}
      >
        {columnConfig.map((c) => (
          <MenuItem key={c.id} onClick={() => setVisibleCols((prev) => ({ ...prev, [c.id]: !prev[c.id] }))}>
            <Checkbox checked={visibleCols[c.id]} size="small" color="primary" />
            {c.label}
          </MenuItem>
        ))}
      </Menu>

      <Menu
        anchorEl={actionMenu.anchor}
        open={Boolean(actionMenu.anchor)}
        onClose={closeActionMenu}
      >
        <MenuItem
          onClick={() => {
            editCalenderAssignment(actionMenu.row);
            closeActionMenu();
          }}
        >
          <EditIcon style={{ fontSize: 18, marginRight: 8, color: '#1769d6' }} /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            deleteCalenderAssignment(actionMenu.row);
            closeActionMenu();
          }}
        >
          <DeleteIcon style={{ fontSize: 18, marginRight: 8, color: '#e53935' }} /> Delete
        </MenuItem>
      </Menu>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        PaperProps={{ className: classes.dialogPaper }}
      >
        <Box className={classes.dialogTitleBar}>
          <Typography className={classes.dialogTitleText}>
            {calenderAssignment._id ? 'Edit Event' : 'Add Event'}
          </Typography>
          <IconButton size="small" onClick={handleClose} disabled={addEventLoading}>
            <CloseIcon style={{ fontSize: 20, color: '#7a8aa0' }} />
          </IconButton>
        </Box>

        <DialogContent className={classes.dialogBody}>
          <Box className={classes.formSection}>
            <Typography className={classes.sectionLabel}>Class &amp; Students</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={formik.touched.classId && Boolean(formik.errors.classId)}
                >
                  <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="classId"
                    label="Select Class"
                    value={formik.values.classId}
                    onChange={(e) => {
                      formik.setFieldValue('sectionId', '');
                      formik.handleChange(e);
                      getSectionListByClass(e.target.value);
                      getStudentList(e.target.value, undefined);
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {addClassList.map(({ _id, className }) => (
                      <MenuItem key={_id} value={_id}>{className}</MenuItem>
                    ))}
                  </Select>
                  {formik.touched.classId && formik.errors.classId && (
                    <FormHelperText>{formik.errors.classId}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" size="small" fullWidth disabled={sectionList.length === 0}>
                  <InputLabel id="section-select-label">Select Section</InputLabel>
                  <Select
                    labelId="section-select-label"
                    id="section-select"
                    name="sectionId"
                    label="Select Section"
                    value={formik.values.sectionId || ''}
                    disabled={sectionList.length === 0}
                    onChange={(e) => {
                      formik.handleChange(e);
                      getStudentList(formik.values.classId, e.target.value || undefined);
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {sectionList.map(({ _id, sectionName }) => (
                      <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox name="isEventForAllStudent" id="terms"
                      color="primary"
                      value={formik.values.isEventForAllStudent}
                      checked={formik.values.isEventForAllStudent}
                      onChange={formik.handleChange}
                    />
                  }
                  label="For All Class Students"
                />
              </Grid>
              {!formik.values.isEventForAllStudent && (
                <Grid item xs={12}>
                  <FormControl variant="outlined" size="small" fullWidth>
                    <InputLabel id="studentName-label">Student Name</InputLabel>
                    <Select
                      labelId="studentName-label"
                      id="studentName-select"
                      label="Student Name"
                      name="studentId"
                      multiple
                      value={formik.values.studentId}
                      onChange={formik.handleChange}
                      renderValue={(selected) => {
                        const selectedNames = studentList
                          .filter(({ _id }) => selected.includes(_id))
                          .map(({ studentName }) => studentName);
                        return selectedNames.join(", ");
                      }}
                    >
                      {studentList.map(({ _id, studentName }) => (
                        <MenuItem key={_id} value={_id}>{studentName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Box>

          <Divider />

          <Box className={classes.formSection} style={{ marginTop: 20 }}>
            <Typography className={classes.sectionLabel}>Event Details</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="eventName"
                  name="eventName"
                  label="Event"
                  type="text"
                  value={formik.values.eventName}
                  onChange={formik.handleChange}
                  error={formik.touched.eventName && Boolean(formik.errors.eventName)}
                  helperText={formik.touched.eventName && formik.errors.eventName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="icon-select-label">Select Icon (Optional)</InputLabel>
                  <Select
                    labelId="icon-select-label"
                    id="iconId"
                    name="iconId"
                    label="Select Icon (Optional)"
                    value={formik.values.iconId || ''}
                    onChange={formik.handleChange}
                    renderValue={(selected) => {
                      if (!selected) return 'None';
                      const selectedIcon = activeIcons.find(icon => icon._id === selected);
                      if (selectedIcon) {
                        return (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <img
                              src={selectedIcon.imageUrl}
                              alt={selectedIcon.iconName}
                              style={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px' }}
                            />
                            <span>{selectedIcon.iconName}</span>
                          </Box>
                        );
                      }
                      return 'None';
                    }}
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {activeIcons.map((icon) => (
                      <MenuItem key={icon._id} value={icon._id}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <img
                            src={icon.imageUrl}
                            alt={icon.iconName}
                            style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '4px' }}
                          />
                          <span>{icon.iconName}</span>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="date"
                  name="date"
                  label="Event Date"
                  type="date"
                  value={formik.values.date}
                  onChange={formik.handleChange}
                  error={formik.touched.date && Boolean(formik.errors.date)}
                  helperText={formik.touched.date && formik.errors.date}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="video"
                  name="video"
                  label="Video Link"
                  type="text"
                  value={formik.values.video}
                  onChange={formik.handleChange}
                  error={formik.touched.video && Boolean(formik.errors.video)}
                  helperText={formik.touched.video && formik.errors.video}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  id="observation"
                  name="observation"
                  label="Special instructions"
                  type="text"
                  multiline
                  minRows={2}
                  value={formik.values.observation}
                  onChange={formik.handleChange}
                  error={formik.touched.observation && Boolean(formik.errors.observation)}
                  helperText={formik.touched.observation && formik.errors.observation}
                />
              </Grid>
            </Grid>
          </Box>

          <Divider />

          <Box className={classes.formSection} style={{ marginTop: 20, marginBottom: 0 }}>
            <Typography className={classes.sectionLabel}>Images</Typography>
            <Box className={classes.uploadBox}>
              <input
                type="file"
                accept="image/*"
                id="calendar-event-upload"
                multiple
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
              <ImageIcon style={{ fontSize: 30, color: '#9aa6b6' }} />
              <Typography style={{ color: '#6b7280', fontSize: '0.82rem', margin: '6px 0 12px' }}>
                Select images, then upload them to attach to this event.
              </Typography>
              <Box display="flex" justifyContent="center" gridGap={10} flexWrap="wrap">
                <label htmlFor="calendar-event-upload">
                  <Button variant="outlined" component="span" size="small" className={classes.cancelBtn} style={{ border: '1px solid #e6eaf0' }}>
                    Choose Images
                  </Button>
                </label>
                <Button size="small" className={classes.uploadBtn} variant="contained" onClick={handleUpload}>
                  Upload
                </Button>
              </Box>
            </Box>

            {pendingPreviews.length > 0 && (
              <Box className={classes.pendingPanel}>
                <Typography style={{ fontWeight: 600, fontSize: '0.82rem', color: '#46566b', marginBottom: 10 }}>
                  {pendingPreviews.length} image{pendingPreviews.length === 1 ? '' : 's'} selected — click Upload to attach
                </Typography>
                <Box display="flex" flexWrap="wrap" gridGap={12}>
                  {pendingPreviews.map((item, index) => (
                    <Box key={item.key} textAlign="center">
                      <Box position="relative" display="inline-block">
                        <img
                          src={item.url}
                          alt={item.file.name}
                          className={classes.previewThumb}
                        />
                        <Button
                          size="small"
                          className={classes.removeThumbBtn}
                          onClick={() => removePendingImageAt(index)}
                          aria-label={`Remove ${item.file.name}`}
                        >
                          ❌
                        </Button>
                      </Box>
                      <Typography className={classes.pendingFileName} title={item.file.name}>
                        {item.file.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}

            {imageslist.length > 0 && (
              <Box display="flex" flexWrap="wrap" gridGap={12} mt={2}>
                {imageslist.map((url, index) => (
                  <Box key={index} position="relative">
                    <img src={url} alt={`Preview ${index + 1}`} className={classes.previewThumb} />
                    <Button
                      size="small"
                      className={classes.removeThumbBtn}
                      onClick={() => removeImage(index, url)}
                    >
                      ❌
                    </Button>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions className={classes.dialogFooter}>
          <Button onClick={handleClose} disabled={addEventLoading} className={classes.cancelBtn}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            className={classes.addBtn}
            onClick={formik.handleSubmit}
            disabled={addEventLoading}
            startIcon={addEventLoading ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {addEventLoading ? "Adding…" : (calenderAssignment._id ? "Update" : "Add")}
          </Button>
        </DialogActions>

      </Dialog>
    </Box>
  );
}

